import axiosIns from "@/libs/axios";

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchSalaries(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("/salary_records/", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    fetchSelfSalaries(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("/salary_records/self", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    fetchSelfInvoices(ctx) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("/salary_records/self/invoices")
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    // fetchSalariesForExport(ctx, queryParams) {
    //   return new Promise((resolve, reject) => {
    //     axiosIns
    //       .get("/salary_records/export", { params: queryParams })
    //       .then((response) => resolve(response))
    //       .catch((error) => reject(error));
    //   });
    // },
    fetchSalariesForExportEnhanced(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("/salary_records/export-enhanced", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    }

  }
};
